import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Alert,
  Button,
  Card,
  Col,
  Input,
  Row,
  Select,
  Table,
  Tabs,
  Typography,
  Upload,
} from "antd";
import styled, { css } from "styled-components";
const { Text } = Typography;

const Yellow = "#FFF995";
const Red = "#FF8C82";
const Gray = "#D6D6D6";
const Green = "#96D35F";

const scheduleRed = "#FFE0E4";
const scheduleGreen = "#E5FFF4";
const scheduleYellow = "#FFD294";
const scheduleDarkGray = "#747476";
const scheduleLightGray = "#E9E9E9";

const backgroundGrey = "#f0f2f5";

const getStatusColor = (color) => css`
  background-color: ${color} !important;
`;

export const DetailsCard = styled(Card)`
  transition: all 0.5s ${({ $open }) => ($open ? "ease-in" : "ease-out")};
  display: ${({ $open }) => ($open ? "block" : "none")};
  opacity: ${({ $open }) => ($open ? "1" : "0")};

  .ant-card-actions > li {
    display: flex;
    justify-content: end;
    padding-right: 12px;
  }
`;

export const StyledScrollWrapper = styled.div`
  overflow-x: auto;
`;

export const AntMilestoneTable = styled(Table)`
  .schedule-table {
    min-width: 250px;
    max-width: 250px;
  }
  td.status {
    &-skipped {
      background-image: linear-gradient(45deg, #f0f2f5 25%, transparent 25%),
        linear-gradient(-45deg, #f0f2f5 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #f0f2f5 75%),
        linear-gradient(-45deg, transparent 75%, #f0f2f5 75%) !important;
      background-size: 20px 20px !important;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px !important;
      transition-duration: 0s !important;
    }
  }

  tr:hover {
    td.status {
      &-skipped {
        background-image: linear-gradient(45deg, #f0f2f5 25%, transparent 25%),
          linear-gradient(-45deg, #f0f2f5 25%, transparent 25%),
          linear-gradient(45deg, transparent 75%, #f0f2f5 75%),
          linear-gradient(-45deg, transparent 75%, #f0f2f5 75%);
        background-size: 20px 20px;
        background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
        transition-duration: 0s !important;
      }
    }
  }

  .ant-table-tbody > tr.ant-table-row > td {
    transition-duration: 0s;
    border-bottom: 1px solid #a9a9a9;
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    position: absolute;
    top: 0%;
    right: 0;
    width: 1px;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.06);
    transform: translateY(0%);
    transition: background-color 0.3s;
    content: "";
  }

  tr:nth-child(6n + 7) > td.status,
  th.status {
    &-approved {
      ${(_) => getStatusColor(scheduleGreen)}
    }
    &-inapproval {
      ${(_) => getStatusColor(scheduleYellow)}
    }
    &-draft {
      ${(_) => getStatusColor(scheduleLightGray)}
    }
    &-rejected {
      ${(_) => getStatusColor(scheduleRed)}
    }
    &-skipped {
      background: #f2f2f2;
    }
    &-released {
      ${(_) => getStatusColor(scheduleGreen)}
    }
    &-blank {
      ${(_) => getStatusColor(scheduleLightGray)}
    }
  }

  tr > td:nth-child(1) {
    font-weight: 500;
  }

  tr > th {
    text-align: center;
    a {
      color: #000000;
      text-decoration: underline;
    }
  }

  tr > th:nth-child(1) {
    ${(_) => getStatusColor(scheduleDarkGray)}
    color: white !important;
    font-weight: bold;
  }

  tr > td:nth-child(n + 2) {
    text-align: center;
  }

  tbody > tr {
    display: ${({ $hideRows }) => ($hideRows ? "none" : undefined)};
  }

  tr:nth-child(6n + 6) td {
    background: unset;
  }
  tr:nth-child(6n + 6):hover {
    td {
      background: unset;
    }
  }

  margin-bottom: 20px;
`;

export const MilestoneExpanderBtn = styled(Button)`
  font-weight: bold;
  ${(props) =>
    props.status.toLowerCase() === "skipped" &&
    css`
      color: #a9a9a9;
    `}

  span {
    text-decoration: underline;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-top: 10px;
`;

export const ModalAlert = styled(Alert)`
  margin-bottom: 20px;
`;

export const InLineUpload = styled(Upload)`
  .ant-upload-list-item {
    float: left;
    width: 300px;
    margin-right: 8px;
  }
`;

export const MobileViewTab = styled.div`
  margin: 0;
  padding: 0;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  width: 90px;
`;

export const ResponsiveTabs = styled(Tabs)`
  width: 100%;
  display: flex;

  padding-right: 0px;

  .ant-tabs-nav-list {
    flex: auto;
    justify-content: space-evenly;
    margin-top: 0px;
    background-color: white;
  }

  .ant-tabs-tab {
    text-align: center;
    margin: 0;
    align: center;
    justify-content: space-around;
  }

  .ant-tabs-nav-wrap {
    border-bottom: 1px solid lightgray;
  }

  .ant-tabs-nav {
    margin-bottom: 0px;

    margin-right: 0px;
    background-color: white;
    border-radius: 8px;
  }

  .ant-tabs-tabpane {
    background-color: ${backgroundGrey};
    margin-top: 20px;
    min-height: 500px;
  }
`;

export const StyledUpload = styled(Upload)`
  .ant-upload-list-item-container {
    margin-block: 0 48px !important;
  }

  .ant-upload-list-item-thumbnail {
    height: 102px;
  }

  .ant-upload-list-picture-card-container {
    width: 115px;
    height: 100%;
  }

  .ant-upload.ant-upload-select-picture-card,
  .ant-upload-list-item-uploading.ant-upload-list-item {
    width: 115px;
    height: 115px;
  }

  .ant-upload-list-item-info > span {
    aspect-ratio: 1 / 1;
  }
`;

export const StyledPanelRowDesktop = styled(Row)`
  transform: translateX(${({ $indent }) => $indent || 0});
  width: calc(100% - ${({ $indent }) => $indent || 0});
  padding-bottom: 4px;
`;

export const OffsetCol = styled(Col)`
  transform: translateX(-${({ $indent }) => $indent || 0});
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 18px;
  ${({ $click }) => ($click === true ? "cursor: pointer;" : "")}
`;

export const StatusAndNameCol = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;

export const StyledStatusIconContainer = styled.div`
  height: 16px;
  width: 22px;
  padding-top: 2px;

  div {
    border: 2pt solid black;
    height: 16px;
    width: 16px;
  }

  .major {
    transform: rotate(45deg);
  }

  .status {
    &-approved {
      ${(_) => getStatusColor(Green)}
    }
    &-inapproval {
      ${(_) => getStatusColor(Yellow)}
    }
    &-draft {
      ${(_) => getStatusColor(Gray)}
    }
    &-rejected {
      ${(_) => getStatusColor(Red)}
    }
    &-released {
      ${(_) => getStatusColor(Green)}
    }
    &-skipped {
      background-color: white;
    }
  }
`;

export const StyledMilestoneName = styled.span`
  font-weight: bold;
  margin-right: 10px;
`;

export const StyledContentCard = styled(Card)`
  ${({ $status }) =>
    $status === "Skipped"
      ? `
  background-image: linear-gradient(45deg, #f0f2f5 25%, transparent 25%),
  linear-gradient(-45deg, #f0f2f5 25%, transparent 25%),
  linear-gradient(45deg, transparent 75%, #f0f2f5 75%),
  linear-gradient(-45deg, transparent 75%, #f0f2f5 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    transition-duration: 0s !important;
  `
      : ""}

  border: 1px solid grey;
  margin: 0;
  height: 100%;
  box-shadow: none;

  .ant-row {
    padding: 0;
  }
`;

export const StyledContentCardExpansion = styled(StyledContentCard)`
  width: 100%;
`;

export const StyledMilestonePanelExpanded = styled(Row)`
  margin-top: 0px;
  background-color: white;
  width: 100%;
`;

export const StyledDateValueContainer = styled.div`
  ${({ $mobile }) => ($mobile === true ? "margin-bottom: 10px;" : "")}
  display: ${({ $mobile }) => ($mobile === true ? "block" : "inline-block")};
  margin-left: 12px;
  vertical-align: top;
  line-height: 1;
  min-width: 66px;
`;

export const StyledDateValueLabel = styled.div`
  margin-bottom: 4px;
  font-size: ${({ $mobile }) => ($mobile === true ? "10pt" : "7pt")};
  vertical-align: top;
`;

export const StyledDateValue = styled.div`
  font-size: ${({ $mobile }) => ($mobile === true ? "12pt" : "9pt")};
  font-weight: bold;

  .ant-picker {
    padding-top: 2px;
    width: 130px;
  }
`;

export const ScheduleRow = styled(Row)`
  padding-bottom: 4px;
  width: 320px;
`;

export const ScheduleInput = styled.div`
  span {
    display: block;
    font-size: 8pt;
  }

  .ant-input {
    width: 100%;
    font-size: 12pt;
    height: 32px;
  }

  .ant-select {
    width: 100%;
    font-size: 12pt;
  }

  .ant-select-selection-item {
    font-size: 12pt;
  }
`;

export const ErrorText = styled.span`
  color: var(--ant-primary-color);
`;

export const StyledSelect = styled(Select)`
  margin-left: 18px;
`;

export const MinWidthDiv = styled.div`
  min-width: ${({ $min }) => ($min || 0) + "px"};
`;

const milestoneColor = (selected, color) => (selected ? color : "none");

export const SelectableMilestone = styled(Row)`
  padding-left: 20px;
  padding-bottom: 4px;
  padding-top: 4px;
  margin-bottom: 4px;
  border: 1px solid silver;
  background-color: ${({ $selected, $color }) =>
    milestoneColor($selected, $color || "none")};
  cursor: pointer;

  span {
    font-size: 12pt;
  }
`;

export const SelectableMilestoneDisplay = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  div {
    font-size: 12pt;
  }
  div:nth-child(2) {
    color: silver;
    font-size: 10px;
    margin-right: 4px;
  }
`;

export const StyledSpacer = styled.div`
  width: ${({ $width }) => ($width ? `${$width}px` : "0px")};
`;

export const ModalDescription = styled.div`
  margin-bottom: 20px;
`;

export const DocumentsRequiredAlert = styled(Alert)`
  margin-top: 10px;
  color: #db011c;
`;

export const DocumentsRequiredAlertIcon = styled(FontAwesomeIcon)`
  font-size: 60px;
  color: #db011c;
`;
export const CenteredIconContainer = styled.div`
  text-align: center;
  font-weight: bold;
`;

export const MilestoneDetailCard = styled(Card)`
  border: none;
  box-shadow: none;
  min-width: 300px;
  .ant-card-head {
    border: none;
  }
  .ant-col > .ant-typography {
    margin-top: 0;
  }
`;

export const MilestoneDetailSubCard = styled(Card)`
  border: none;
  box-shadow: none;
  min-width: 300px;
  .ant-card-head {
    border: none;
  }
  .ant-card-body {
    padding: 0px 24px;
  }
`;

export const ApproverInputContainer = styled.div`
  width: 70%;
  display: inline-block;
`;

export const ApproverActionsContainer = styled.div`
  min-width: 160px;
  display: inline-block;
  padding-left: 8px;
`;

export const ApproverIconContainer = styled.div`
  padding-top: 2px;
  padding-bottom: 2px;
  display: flex;

  height: 32px;
  width: 80px;
  svg {
    height: 28px;
    margin-left: 12px;
    display: inline-block;
  }
`;

export const MilestoneSubmitModalTextContainer = styled.div`
  margin-top: 10px;
  color: #db011c;
`;

export const ReadOnlyInput = styled(Input)`
  background-color: ${({ $color }) => $color};
  border: none;
`;

export const CustomWidthDiv = styled.div`
  width: ${({ $width }) => $width};
`;

export const SelectArrowStyle = styled(Select)`
  .ant-select-arrow {
    font-size: 18px;
    color: black;
  }
`;

export const AttributeRow = styled(Row)`
  color: #ad0015;
  font-weight: bold;
  padding-right: 20px;
  line-height: 1;
  font-size: 14px;
`;

export const ScheduleHeaderText = styled(Text)`
  color: white !important;
`;

export const RegionDisplayCol = styled(Col)`
  min-width: 300px;
  max-width: 500px;
`;
